import { useMemo } from 'react';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Flex } from 'foundations-components/components/Flex';
import { useHistory, useParams } from 'react-router-dom';
import { useTicket } from '../data/useTicket';
import { H3 } from 'foundations-components/transitional/components/H3';
import { Tabs, Tab } from 'foundations-components/transitional/components/Tabs';
import { getChannelDisplayName } from '../utils/getChannelDisplayName';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { CHANNEL_ICONS } from '../constants/channelIcons';
import { NotificationPopupIcon } from 'foundations-assets/icons/components/NotificationPopupIcon';
import { sortThreadsByLatest } from '../utils/sortThreadsByLatest';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import styled from 'foundations-theming-specialty/utils';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ConversationsLabel = styled.span.withConfig({
  displayName: "ThreadHistoryHeader__ConversationsLabel"
})(["font-size:", ";font-weight:", ";color:", ";"], ({
  theme
}) => theme.typography['body-100'].fontSize, ({
  theme
}) => theme.typography['body-300'].fontWeight, ({
  theme
}) => theme.color['text-core-default']);
export const ThreadHistoryHeader = ({
  threads
}) => {
  const history = useHistory();
  const {
    ticketId,
    threadId
  } = useParams();
  const {
    data: ticket
  } = useTicket(Number(ticketId));
  const subjectValue = (ticket === null || ticket === void 0 ? void 0 : ticket['subject']) || '';
  const sortedThreads = useMemo(() => {
    return sortThreadsByLatest(threads);
  }, [threads]);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "200",
    maxInlineSize: "100%",
    children: [/*#__PURE__*/_jsx(H2, {
      typography: "heading-300",
      marginBlockEnd: "0",
      children: subjectValue
    }), /*#__PURE__*/_jsxs(H3, {
      typography: "detail-200",
      marginBlockEnd: "0",
      children: ["#", ticketId]
    }), /*#__PURE__*/_jsx(Flex, {
      flexDirection: "row",
      gap: "200",
      alignItems: "center",
      children: sortedThreads.length > 1 && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Tooltip, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customer-portal-app.ticketThread.conversationsTooltip"
          }),
          children: /*#__PURE__*/_jsx(ConversationsLabel, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "customer-portal-app.ticketThread.conversations"
            })
          })
        }), /*#__PURE__*/_jsx(Tabs, {
          onSelectedChange: e => {
            const nextThreadId = e.target.value;
            history.push(`/ticket/${ticketId}/${String(nextThreadId)}`);
          },
          selected: threadId,
          bordered: true,
          children: sortedThreads.map(thread => {
            const channelDisplayName = getChannelDisplayName(thread.originalChannel);
            const tabTitle = I18n.moment(thread.startedAt).format('MMM D');
            const tooltipChannel = channelDisplayName.toLowerCase();
            const tooltipLatestActivityDate = I18n.moment(thread.latestMessageTimestamp || thread.startedAt).format('L LT');
            return /*#__PURE__*/_jsx(Tab, {
              tabId: `${thread.threadId}`,
              title: tabTitle,
              icon: CHANNEL_ICONS[thread.originalChannel] || NotificationPopupIcon,
              tooltip: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: "customer-portal-app.ticketThread.threadTabTooltip",
                options: {
                  latestActivityDate: tooltipLatestActivityDate,
                  channel: tooltipChannel
                }
              })
            }, `${thread.threadId}`);
          })
        })]
      })
    })]
  });
};